module.exports = __webpack_public_path__ + "static/media/JB-Bold.f67658b3.otf";